var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPhotos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 3.99975H1.99975C1.86634 3.99173 1.73274 4.0121 1.60778 4.05952C1.48282 4.10694 1.36934 4.18032 1.27483 4.27483C1.18032 4.36934 1.10694 4.48282 1.05952 4.60778C1.0121 4.73274 0.99173 4.86634 0.99975 4.99975V14.9997C0.99173 15.1332 1.0121 15.2668 1.05952 15.3917C1.10694 15.5167 1.18032 15.6302 1.27483 15.7247C1.36934 15.8192 1.48282 15.8926 1.60778 15.94C1.73274 15.9874 1.86634 16.0078 1.99975 15.9997H15.9997C16.1332 16.0078 16.2668 15.9874 16.3917 15.94C16.5167 15.8926 16.6302 15.8192 16.7247 15.7247C16.8192 15.6302 16.8926 15.5167 16.94 15.3917C16.9874 15.2668 17.0078 15.1332 16.9998 14.9997V4.99975C17.0078 4.86634 16.9874 4.73274 16.94 4.60778C16.8926 4.48282 16.8192 4.36934 16.7247 4.27483C16.6302 4.18032 16.5167 4.10694 16.3917 4.05952C16.2668 4.0121 16.1332 3.99173 15.9997 3.99975ZM14.9997 13.9997H2.99975V5.99975H14.9997V13.9997Z",
    fill: "#8E8E8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0H3V2H15V0Z",
    fill: "#8E8E8E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13L11 8L14 13H6Z",
    fill: "#8E8E8E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10C6.55228 10 7 9.55228 7 9C7 8.44772 6.55228 8 6 8C5.44772 8 5 8.44772 5 9C5 9.55228 5.44772 10 6 10Z",
    fill: "#8E8E8E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhotos);
export default __webpack_public_path__ + "static/media/icon_photos.7bab43af.svg";
export { ForwardRef as ReactComponent };